export default {
  UPSERT_PRICE_BOOK_FORM: 'upsertPriceBookForm',
  IMPORT_PRICE_BOOK_FORM: 'importPriceBookForm',
  DELETE_PRICE_BOOK_FORM: 'deletePriceBookForm',
  EXPORT_PRICE_BOOK_FORM: 'exportPriceBookForm',
};
